import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { APPLINKS_V3_QUERY_SINGULAR_URL } from './applinksListPageUrl.constants.tsx';
import type { ApplicationLinkV3Data } from './CommonApplicationLinkCreationEntity.tsx';

export const fetchApplink = (id: string): Promise<ApplicationLinkV3Data> =>
	fetchJson(APPLINKS_V3_QUERY_SINGULAR_URL(id));
